import { IPreferences } from "@/androidPlugins/IPreferences"

type GridModePreferences = Record<string, boolean>
const gridModePreferencesKey = "gridModePreferences"

const { cashierId } = useAuth()
const getCurrentCashierIdentifier = () =>
  cashierId.value ?? "default"

const gridModePreferences = ref<
  GridModePreferences | undefined
>()

const hydrateGridModePreferences = async () => {
  const { value: rawPreferences } = await IPreferences.get({
    key: gridModePreferencesKey,
  })

  gridModePreferences.value =
    rawPreferences === null
      ? {}
      : JSON.parse(rawPreferences)
}

const gridModeEnabled = computed({
  get: () =>
    gridModePreferences.value?.[
      getCurrentCashierIdentifier()
    ] ?? true,
  set: async (value: boolean) => {
    if (!gridModePreferences.value) {
      await hydrateGridModePreferences()
    }

    if (!gridModePreferences.value) return

    gridModePreferences.value[
      getCurrentCashierIdentifier()
    ] = value

    await IPreferences.set({
      key: gridModePreferencesKey,
      value: JSON.stringify(gridModePreferences.value),
    })
  },
})

export const useGridMode = () => {
  if (!gridModePreferences.value) {
    hydrateGridModePreferences()
  }

  return { gridModeEnabled }
}
